import { makeVar } from "@apollo/client";

export * from "./updateCacheAfterSavedSearchRemoval";
export * from "./updateCacheAfterSavedSearchAddition";
export * from "./updateCacheAfterFavouriteClubRemoval";
export * from "./updateCacheForFavouriteClub";

export const companyEquityTypeInfoIdVar = makeVar<string | null | undefined>(
  null
);

export const chartPeriodCodeVar = makeVar<string | null | undefined>(
  null
);